var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H0V0H16V16Z",
    stroke: "#E5E7EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_36354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.5C4.5 0.225 4.275 0 4 0C3.725 0 3.5 0.225 3.5 0.5V1H3C2.725 1 2.5 1.225 2.5 1.5C2.5 1.775 2.725 2 3 2H3.5V3H1.88125C1.53437 3 1.25 3.28437 1.25 3.63125C1.25 3.70937 1.26562 3.78437 1.29062 3.85938L2.30625 6.5H2.25C1.83438 6.5 1.5 6.83437 1.5 7.25C1.5 7.66563 1.83438 8 2.25 8H2.375L1.875 12H6.125L5.625 8H5.75C6.16563 8 6.5 7.66563 6.5 7.25C6.5 6.83437 6.16563 6.5 5.75 6.5H5.69375L6.70937 3.85938C6.7375 3.7875 6.75 3.70937 6.75 3.63125C6.75 3.28125 6.46563 3 6.11875 3H4.5V2H5C5.275 2 5.5 1.775 5.5 1.5C5.5 1.225 5.275 1 5 1H4.5V0.5ZM1.5 13L0.15 14.8C0.053125 14.9313 0 15.0875 0 15.25C0 15.6656 0.334375 16 0.75 16H7.25C7.66563 16 8 15.6656 8 15.25C8 15.0875 7.94688 14.9313 7.85 14.8L6.5 13H1.5ZM10.5 13L9.15 14.8C9.05312 14.9313 9 15.0875 9 15.25C9 15.6656 9.33438 16 9.75 16H15.25C15.6656 16 16 15.6656 16 15.25C16 15.0875 15.9469 14.9313 15.85 14.8L14.5 13H10.5ZM9.5 6.5V8.12187C9.5 8.36562 9.5875 8.6 9.75 8.78125L10.6 9.75L10.5312 12H14.4531L14.35 9.75L15.2344 8.7875C15.4031 8.60313 15.5 8.3625 15.5 8.10938V6.5C15.5 6.225 15.275 6 15 6H14.5C14.225 6 14 6.225 14 6.5V7H13.25V6.5C13.25 6.225 13.025 6 12.75 6H12.25C11.975 6 11.75 6.225 11.75 6.5V7H11V6.5C11 6.225 10.775 6 10.5 6H10C9.725 6 9.5 6.225 9.5 6.5ZM12 9.5C12 9.225 12.225 9 12.5 9C12.775 9 13 9.225 13 9.5V10.5H12V9.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_36354"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChessIcon);
export default __webpack_public_path__ + "static/media/chess-icon.ab7d1aa022a0c0c94839f000d7b2ad86.svg";
export { ForwardRef as ReactComponent };